import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  path = "/",
  image,
}) {
  const url = `https://scudononni.it${path}`;
  const finalTitle = title
    ? `${title} | ScudoNonni`
    : "Verifica Truffa Online Gratis — SMS, WhatsApp, Email | ScudoNonni";
  const finalDescription =
    description ||
    "Hai ricevuto un SMS sospetto, una email strana o un messaggio WhatsApp? Verifica gratis in pochi secondi se è una truffa o phishing. Semplice, anonimo, per anziani e famiglie.";
  const finalImage =
    image ||
    "https://customer-assets.emergentagent.com/job_40ad2524-223c-429c-8f1d-4ea2ecf9a2d3/artifacts/6n4i34v7_logo.png";

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={finalImage} />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />
    </Helmet>
  );
}
